import React from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import FinancialStatusIcon from '../status/FinancialStatusIcon';
import Text from 'components/_UI/Text';
import date from 'helpers/date';
import time from 'helpers/time';
import currency from 'helpers/currency';
import { DollarSign } from 'react-feather';
import { FullyCentered } from 'styled/alignment/Center';

export default function GeneralTransactions({ data }) {
    const transactionTypes = {
        withdraw: 'withdraw',
        refund: 'refund',
        sell: 'sell'
    }

    return (
        <TransactionContainer>

            {
                data && data?.length > 0 ?
                    data.map((transaction) => (
                        <TransactionItem key={transaction.id}>
                            <Row>
                                <FinancialStatusIcon status={transaction?.category} />

                                <TextInfoContent>
                                    <Text paddingBottom={0} color={colors.nightDark} >
                                        {transaction.description}
                                    </Text>
                                    <Text paddingBottom={0}>
                                        {`${date.format(transaction.created_at)} - ${time.getFormatedTime(transaction.created_at)}`}
                                    </Text>
                                </TextInfoContent>
                            </Row>

                            <PriceColumn>

                                {
                                    (transaction?.category === transactionTypes.refund || transaction?.category === transactionTypes.withdraw) && (
                                        <Text
                                            paddingBottom={0}
                                            color={colors.danger}
                                            name='normal'
                                        >
                                            -{currency.format(transaction.liquid_value)}
                                        </Text>
                                    )
                                }

                                {
                                    transaction?.category === transactionTypes.sell && (
                                        <Text
                                            paddingBottom={0}
                                            color={colors.success}
                                            name='normal'
                                        >
                                            {currency.format(transaction.liquid_value)}
                                        </Text>
                                    )
                                }

                                <StatusText status='success'>
                                    Processado
                                </StatusText>
                            </PriceColumn>
                        </TransactionItem>
                    )) : (
                        <NotFoundContainer>
                            <PigIconContainer>
                                <DollarSign name='pig' color={colors.occasionalPurple} />
                            </PigIconContainer>

                            <Text type='bold' name='normal' color={colors.nightDark}>
                                Você não possui transações recentes
                            </Text>
                            <Text textAlign={'center'}>
                                Suas proximas transações irão ser listadas aqui.
                            </Text>
                        </NotFoundContainer>
                    )
            }


            {/* <TransactionItem>
                <Row>
                    <FinancialStatusIcon status={transactionTypes.withdraw'} />

                    <TextInfoContent>
                        <Text paddingBottom={0} color={colors.nightDark} >
                            Ingresso - Festa do Lucas
                        </Text>
                        <Text paddingBottom={0}>27/06/2025</Text>
                    </TextInfoContent>
                </Row>

                <PriceColumn>
                    <Text paddingBottom={0} color={colors.success} >
                        R$ 450,00
                    </Text>
                    <StatusText status='pending'>
                        Pendente
                    </StatusText>
                </PriceColumn>
            </TransactionItem> */}

        </TransactionContainer>
    )
}


const TransactionContainer = styled(Column)`
`;

const TextInfoContent = styled(Column)`
    width: auto;
`;

const TransactionItem = styled(Row)`
    margin-top: 20px;
    justify-content: space-between;
`;


const PriceColumn = styled(Column)`
    width: 150px;
    padding: 0 4px;
    text-align: center;
`;

const StatusText = styled.p`
    padding: 4px 2px;
    margin-top: 4px;
    font-size: ${fonts.sizes.small} !important;
    border-radius: 50px;
    text-align: center;
    color: ${colors.night};
    font-weight: bold;

    ${({ status }) => status === 'pending' && `
        background: #FEF9C3;
        color: ${colors.occasionalOrange};
        border: 1px solid ${colors.occasionalOrange};
    `};
    
    ${({ status }) => status === 'success' && `
        background: #DCFCE7;
        color: ${colors.successDark};
        border: 1px solid ${colors.successDark};
    `};
`

const PigIconContainer = styled(FullyCentered)`
    width: 65px;
    height: 65px;
    padding: 18px;
    border-radius: 50%;
    background: #F3E8FF;
    margin-bottom: 10px;
`;

const NotFoundContainer = styled(FullyCentered)`
    flex-direction: column;
    padding: 40px 1.5em;
`;